import { VinoDataSKU } from "../../types/vino-data-types";
import { isSingleVinoDataWineSKU } from "./sku";

export const volumeFromVinoDataSKU = (sku: VinoDataSKU): string => {
  if (!sku) return undefined;

  const [wine] = sku.wines;

  return isSingleVinoDataWineSKU(sku) && wine ? wine.bottleVolume : undefined;
};
